import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  unit,
  heat_treatment,
  surface_treatment,
  target_date,
  remarks,
  leadTime,
} from '@/table/Job/SubJob/base';

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    amount,
    assembly_failed_amount: {
      name: 'ล้มเหลว',
      width: '5rem',
      class: 'text-right',
    },
    unit,
    heat_treatment,
    surface_treatment,
    target_date,
    remarks,
    leadTime,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'assembly_failed_amount',
    'unit',
    'heat_treatment',
    'surface_treatment',
    'target_date',
  ],
};
